import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import TGNewsSider from './tgNewsSider';
import TGNews from './tgNews';

class TechAndGuoxue extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { tgNewsSiderData, tgNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <TGNewsSider content={tgNewsSiderData} />
                <TGNews content={tgNewsData} />
            </div>
        );
    }
}

export default errorBoundary(TechAndGuoxue);
